export const constant = {
	selector: {
		target: '.feedback-messenger-window .wysiwyg',
	},
}
